'use strict';
define('pokerCards',[], function () {
	return {
    cards: {
      102:	{ suit: 'spades', value:	'2' },
      103:	{ suit: 'spades', value:	'3' },
      104:	{ suit: 'spades', value:	'4' },
      105:	{ suit: 'spades', value:	'5' },
      106:	{ suit: 'spades', value:	'6' },
      107:	{ suit: 'spades', value:	'7' },
      108:	{ suit: 'spades', value:	'8' },
      109:	{ suit: 'spades', value:	'9' },
      110:	{ suit: 'spades', value:	'10' },
      111:	{ suit: 'spades', value:	'J' },
      112:	{ suit: 'spades', value:	'Q' },
      113:	{ suit: 'spades', value:	'K' },
      114:	{ suit: 'spades', value:	'A' },
      202:	{ suit: 'hearts', value:	'2' },
      203:	{ suit: 'hearts', value:	'3' },
      204:	{ suit: 'hearts', value:	'4' },
      205:	{ suit: 'hearts', value:	'5' },
      206:	{ suit: 'hearts', value:	'6' },
      207:	{ suit: 'hearts', value:	'7' },
      208:	{ suit: 'hearts', value:	'8' },
      209:	{ suit: 'hearts', value:	'9' },
      210:	{ suit: 'hearts', value:	'10' },
      211:	{ suit: 'hearts', value:	'J' },
      212:	{ suit: 'hearts', value:	'Q' },
      213:	{ suit: 'hearts', value:	'K' },
      214:	{ suit: 'hearts', value:	'A' },
      302:	{ suit: 'clubs', value:	'2' },
      303:	{ suit: 'clubs', value:	'3' },
      304:	{ suit: 'clubs', value:	'4' },
      305:	{ suit: 'clubs', value:	'5' },
      306:	{ suit: 'clubs', value:	'6' },
      307:	{ suit: 'clubs', value:	'7' },
      308:	{ suit: 'clubs', value:	'8' },
      309:	{ suit: 'clubs', value:	'9' },
      310:	{ suit: 'clubs', value:	'10' },
      311:	{ suit: 'clubs', value:	'J' },
      312:	{ suit: 'clubs', value:	'Q' },
      313:	{ suit: 'clubs', value:	'K' },
      314:	{ suit: 'clubs', value:	'A' },
      402:	{ suit: 'diamonds', value:	'2' },
      403:	{ suit: 'diamonds', value:	'3' },
      404:	{ suit: 'diamonds', value:	'4' },
      405:	{ suit: 'diamonds', value:	'5' },
      406:	{ suit: 'diamonds', value:	'6' },
      407:	{ suit: 'diamonds', value:	'7' },
      408:	{ suit: 'diamonds', value:	'8' },
      409:	{ suit: 'diamonds', value:	'9' },
      410:	{ suit: 'diamonds', value:	'10' },
      411:	{ suit: 'diamonds', value:	'J' },
      412:	{ suit: 'diamonds', value:	'Q' },
      413:	{ suit: 'diamonds', value:	'K' },
      414:	{ suit: 'diamonds', value:	'A' }
    },
	};
});

